module.exports = __webpack_public_path__ + "img/signup_carousel_1.3f5e5894.svg";